import React, { Component } from 'react';
import { AppContext } from './../AppContext';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Spinner } from 'reactstrap';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FaHome, FaUserGraduate } from 'react-icons/fa';
import { ImExit } from 'react-icons/im';
import { BiPackage } from 'react-icons/bi';
import { GiCardboardBoxClosed, GiFiles } from 'react-icons/gi';
import { AiFillContacts, AiOutlineSync } from 'react-icons/ai';
import { FaBookReader, FaUserSecret, FaUserCircle, FaShieldAlt } from "react-icons/fa";
import { RiShieldStarFill, RiFileList3Fill } from "react-icons/ri";
import './NavMenu.css';
import logo from './Imagenes/Iconos/ESPOL-ExperienciaEstudiantil.svg';
import url from "./variables/url.js";
import CasClient, { constant } from "react-cas-client";
import { ReactComponent as GestionIcon } from './Imagenes/Iconos/GESTION.svg';
import Swal from 'sweetalert2';

import gestion from './Imagenes/Iconos/GESTION.svg';
import carga from './Imagenes/Iconos/cargamasiva.svg';
import { Alert } from 'bootstrap';
/*const CAS_PARAMS = url.cas.split("://");*/
const CAS_PARAMS = process.env.REACT_APP_CAS.split("://");
const casOptions = { version: constant.CAS_VERSION_2_0, path: '/', protocol: CAS_PARAMS[0] };
const casClient = new CasClient(CAS_PARAMS[1], casOptions);
const homepage = process.env.REACT_APP_EXP;
const backurl = process.env.REACT_APP_BACK;

const ColoredLine = ({ color }) => (
    <hr
        style={{
            color: color,
            backgroundColor: color,
            height: 2
        }}
    />
);

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

    logout() {
        casClient.logout();
    }

    updateInsignias() {

        Swal.fire({
            title: "Cargando...",
            html: "Por favor, espere",
            timerProgressBar: true,
            button: false,
            closeOnClickOutside: false,
            showConfirmButton: false,
            closeOnEsc: false,
            allowOutsideClick: false
        });
        Swal.showLoading();

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: null
        };
        fetch(backurl + '/api/ResultadoInsignia/UpdateInsignias', requestOptions)
            .then(response => response.json())
            .then(function (data) {
                Swal.fire({
                    title: 'Hecho',
                    icon: 'success',
                    html: data.strMensaje
                });
            }
        )
    }

  render() {
      const currentUser = this.context;           
    return (
        <header>
                <Row>
                    <Col>
                        <img src={logo} style={{ width: "75%", height: "100%" }} />
                    </Col>
                    <Col>
                    {currentUser && currentUser.idpersona > 0 ?
                        <div className="name-Navbar icon-pointer" style={{ textAlign: 'right', position: 'relative', top: '50%', padding: '1vw' }}>{currentUser.apellidos} {currentUser.nombres} &nbsp; {currentUser.usuario === 'dyance' ? <FaUserSecret /> : < FaUserGraduate />}</div>
                            :
                            ''
                    }                    
                    </Col>
                </Row>            
        <ColoredLine color="#010453" />
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
            {/*<Container>*/}
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
               <ul className="navbar-nav flex-grow">
                <NavItem>
                            {currentUser && currentUser.idpersona > 0 && currentUser.roles.includes('ADMINISTRADOR') ?
                                <NavLink tag={Link} className="text-dark" to="#"><AiOutlineSync title="Actualizar" onClick={this.updateInsignias} /></NavLink>
                                : <></>}
                </NavItem>
                <NavItem>
                    {currentUser && currentUser.idpersona > 0 && currentUser.roles.includes('ADMINISTRADOR') ?
                        <NavLink tag={Link} className="text-dark" to={homepage + "ConsultarReportes"}><GiFiles title="Certificados" /></NavLink>
                        : <></>}
                </NavItem>
                <NavItem>
                    {currentUser && currentUser.idpersona > 0 && currentUser.roles.includes('ADMINISTRADOR') ?
                        <NavLink tag={Link} className="text-dark" to={homepage + "ConsultarInsignias"}><FaShieldAlt title="Insignias" /></NavLink>
                        : <></>}
                </NavItem>
                <NavItem>
                    {currentUser && currentUser.idpersona > 0 && currentUser.roles.includes('ADMINISTRADOR') ?
                                <NavLink tag={Link} className="text-dark" to={homepage + "ConsultarPerfil"}><FaUserCircle title="Consultar Perfil" /></NavLink>
                        : <></>}
                </NavItem>
                <NavItem>
                            {currentUser && currentUser.idpersona > 0 && currentUser.roles.includes('ADMINISTRADOR') ?
                                <NavLink tag={Link} className="text-dark" to={homepage+"CargaMasiva"}><GiCardboardBoxClosed title="Carga Masiva" /></NavLink>
                     : <></>}
                </NavItem>
                <NavItem>
                            {currentUser && currentUser.idpersona > 0 && currentUser.roles.includes('ADMINISTRADOR') ?
                                <NavLink tag={Link} className="text-dark" to={homepage+"GestionActividad"}><AiFillContacts title="Gestion" /></NavLink>
                   : <></>}
                        </NavItem>
                        <NavItem hidden>
                            <NavLink tag={Link} className="text-dark" to="/Act-Est"><FaBookReader title="Actividades" /></NavLink>
                        </NavItem>
                        <NavItem hidden>
                            <NavLink tag={Link} className="text-dark" to="/Insignia"><RiShieldStarFill title="Insignias" /></NavLink>
                        </NavItem>
                        <NavItem hidden>
                            <NavLink tag={Link} className="text-dark" to="/Reporte"><RiFileList3Fill title="Reportes" /></NavLink>
                        </NavItem>
                <NavItem hidden>
                            <NavLink tag={Link} className="text-dark" to="/"><FaHome title="Home" /></NavLink>
                </NavItem>                  
                <NavItem>
                   {currentUser && currentUser.idpersona > 0 ?
                    <>                                        
                           <NavLink tag={Link} className="text-dark" to="#"><ImExit title="Salir" onClick={this.logout} /></NavLink>
                    </>
                    :
                    ''
                    }
                 </NavItem>
              </ul>
            </Collapse>
          {/*</Container>*/}
        </Navbar> 
     </header>
    );
  }
}
NavMenu.contextType = AppContext;